@for (notification of notifications; track notification) {
  <div class="notification" (click)="notificationClicked(notification)" animate.leave="closed">
    <div class="status-indicator" [ngClass]="{ 'status-indicator-read' : notification.status != notificationStatus.New }">
      <div class="rectangle"></div>
    </div>
    <div class="details">
      <div class="creation-data">{{ notification.created | customDate: 'fullDateTime' }}{{ notification.createdById ? ' - ' + (notification.createdById | user: 'name') : '' }}</div>
      @if (notification.company) {
        <div class="company-name">{{ notification.company.name }}</div>
      }
      @if (notification.breadcrumb) {
        <div class="notification-breadcrumb">{{ notification.breadcrumb }}</div>
      }
      <div class="notification-message">{{ notification.message }}</div>
    </div>
    <icon small type="times" class="notification-close" (click)="deleteNotification(notification); $event.stopPropagation()" />
  </div>
}
@if (notifications.length == 0) {
  <div class="no-notifications">
    <div>{{ 'notifications.no-notifications' | translate }}</div>
  </div>
}
